export default __webpack_public_path__ + "static/media/hk.c74d6bfe.png";